// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading___22IZd","loading-content":"loading-content___SeLe_","loading-text":"loading-text___14wlz"};